import React from 'react'
import styled, { ITheme } from '../../theme'
import { TListing } from '../../models/Integration/request/handleResponse'
import airbnb from '../../assets/integrations/airbnbminiicon.svg'
import airbnbadd from '../../assets/integrations/airbnbadd.svg'
import airbnbcancel from '../../assets/integrations/cancel.svg'
import airbnbedit from '../../assets/integrations/pen.svg'
import { IconButton } from '@material-ui/core'
import mapRoomTypeToIcon from '../../models/Room/mappers/mapRoomTypeToIcon'
import { useDispatch } from 'react-redux'
import useFindRoomById from '../../hooks/useFindRoomById'
import { getAirbnbRoomConfiguration } from '../../actions/airbnb'
import { is } from '../MediaQuery'
import { withRouter } from 'react-router'
import { IntegrationAction } from '../../reducers/airbnb/actionNames'

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 10px;
  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    padding: 8px 15px 8px 25px;
  }
`

const NameAir = styled.div`
  background-size: cover;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  color: #696a6d;
  text-decoration: none solid rgb(105, 106, 109);
  font-weight: 500;
  margin-left: 18px;

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    background-size: cover;
    font-family: Montserrat;
    font-size: 12px;
    color: #696a6d;
    text-decoration: none solid rgb(105, 106, 109);
  }
`

const Name = styled.div`
  background-size: cover;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  color: #696a6d;
  text-decoration: none solid rgb(105, 106, 109);
  font-weight: 500;
  margin-left: 20px;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    background-size: cover;
    font-family: Montserrat;
    font-size: 12px;
    color: #696a6d;
    text-decoration: none solid rgb(105, 106, 109);
  }
`

const Id = styled.div`
  background-size: cover;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #696a6d;
  text-decoration: none solid rgb(105, 106, 109);
  margin-left: 20px;

  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    background-size: cover;
    font-family: Montserrat;
    font-size: 12px;
    color: #696a6d;
    text-decoration: none solid rgb(105, 106, 109);
  }
`

const AirbnbRoom = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
`

function Listing({
  listing,
  mobile,
  history,
  unblock,
  disableBorder,
  setOpenDisconnect,
  setOpenConnect,
}: IListing) {
  const findRoomById = useFindRoomById()
  const room = findRoomById(String(listing.bedbooking_id_room), false)

  // mapRoomTypeToIcon(room)
  const dispatch = useDispatch()

  const isDesktop = is.desktop()

  const disconnectListingClick = () => {
    setOpenDisconnect(listing)
    dispatch({ type: IntegrationAction.SetAirbnbBackdrop, payload: true })
  }

  const openConnectModal = () => {
    setOpenConnect(listing)
    dispatch({ type: IntegrationAction.SetAirbnbBackdrop, payload: true })
  }

  const goToRoomSetting = () => {
    dispatch(getAirbnbRoomConfiguration(listing.bedbooking_id_room))
    if (unblock) {
      unblock()
    }
    history.push(
      mobile ? '/integration/room?mobile=1' : '/integration/room',
      {},
    )
  }

  return (
    <div
      style={{
        width: '100%',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/*<PriceModal*/}
      {/*  open={!!openPrice}*/}
      {/*  listing={listing}*/}
      {/*  currency={currency}*/}
      {/*  loading={loading}*/}
      {/*  handleClose={() => setOpenPrice(false)}*/}
      {/*  action={connectRoom(openPrice)}*/}
      {/*/>*/}
      <Wrapper
        key={isDesktop + 'wrapper'}
        onClick={
          !isDesktop ? (!!room ? goToRoomSetting : openConnectModal) : undefined
        }
        style={
          !!room
            ? {
                borderRadius: '10px 10px 0px 0px',
                backgroundColor: '#f0faf4',
                cursor: isDesktop ? 'unset' : 'pointer',
                paddingBottom: isDesktop ? '5px' : '2px',
              }
            : {
                cursor: isDesktop ? 'unset' : 'pointer',
                border: isDesktop ? '1px solid #d9d9d9' : 'unset',
                borderBottom: isDesktop
                  ? '1px solid #d9d9d9'
                  : '1px solid #d9d9d9',
                borderRadius: isDesktop ? '8px' : '0px',
              }
        }
      >
        <AirbnbRoom>
          <img
            src={airbnb}
            alt={'airbnb icon'}
            style={{
              width: isDesktop ? '23px' : '20px',
              height: isDesktop ? '23px' : '20px',
            }}
          />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              minWidth: '0',
            }}
          >
            <NameAir>{listing.name}</NameAir>
            <Id>ID: {listing.id}</Id>
          </div>
        </AirbnbRoom>
        <IconButton
          style={{
            paddingRight: !!room ? '14px' : '16px',
          }}
          onClick={!!room ? goToRoomSetting : openConnectModal}
        >
          <img
            src={!!room ? airbnbedit : airbnbadd}
            alt={'add icon'}
            style={{
              width: isDesktop
                ? !!room
                  ? '25px'
                  : '23px'
                : !!room
                ? '22px'
                : '20px',
              height: isDesktop
                ? !!room
                  ? '25px'
                  : '23px'
                : !!room
                ? '22px'
                : '20px',
              filter: !!room
                ? 'invert(39%) sepia(8%) saturate(39%) hue-rotate(187deg) brightness(100%) contrast(83%)'
                : 'unset',
            }}
          />
        </IconButton>
      </Wrapper>
      {!!room && (
        <>
          <Wrapper
            style={
              !!room
                ? {
                    borderRadius: '0px 0px 10px 10px',
                    backgroundColor: '#f0faf4',
                    paddingTop: isDesktop ? '5px' : '2px',
                  }
                : {}
            }
          >
            <AirbnbRoom>
              <img
                alt={'room icon'}
                style={{
                  width: isDesktop ? '23px' : '20px',
                  height: isDesktop ? '23px' : '20px',
                }}
                src={mapRoomTypeToIcon(room)}
              />
              <div>
                <Name>{room.name}</Name>
              </div>
            </AirbnbRoom>
            <IconButton onClick={disconnectListingClick}>
              <img
                src={airbnbcancel}
                alt={'cancel icon'}
                style={{
                  width: isDesktop ? '20px' : '18px',
                  height: isDesktop ? '20px' : '18px',
                  marginRight: '5px',
                  filter:
                    'invert(44%) sepia(80%) saturate(651%) hue-rotate(312deg) brightness(100%) contrast(104%)',
                }}
              />
            </IconButton>
          </Wrapper>
        </>
      )}
    </div>
  )
}

export interface IListing {
  listing: TListing
  disableBorder?: boolean
  mobile?: boolean
  history?: any
  unblock?: any
  setOpenConnect?: any
  setOpenDisconnect?: any
}

export default withRouter(Listing as any) as any
